import { createSelector } from 'reselect';

import prop from 'lodash/fp/prop';
import isEmpty from 'lodash/fp/isEmpty';
import identity from 'lodash/identity';

import filter from 'lodash/fp/filter';
import pipe from 'lodash/fp/pipe';
import orderBy from 'lodash/fp/orderBy';
import take from 'lodash/fp/take';

export const getFilteredPlayers = createSelector(
  [prop('players.list'), prop('players.keyword')],
  (list, keyword) =>
    isEmpty(keyword)
      ? []
      : pipe(
          filter(({ name }) =>
            name.toLowerCase().includes(keyword.toLowerCase())
          ),
          orderBy(['name'], ['ASC']),
          take(5)
        )(list)
);

export const getPlayerQuery = createSelector(prop('players.keyword'), identity);

export const isPlayerDirty = createSelector(
  [prop('players.selected'), prop('user.scorer')],
  (currentSelected, userScorer) =>
    isEmpty(currentSelected) ? false : currentSelected !== userScorer
);
